import { render, staticRenderFns } from "./signup-step-account.vue?vue&type=template&id=137f68ce&scoped=true&"
import script from "./signup-step-account.vue?vue&type=script&lang=ts&"
export * from "./signup-step-account.vue?vue&type=script&lang=ts&"
import style0 from "./signup-step-account.vue?vue&type=style&index=0&id=137f68ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f68ce",
  null
  
)

export default component.exports